import t from "../../helpers/t";
import FormItem from "../FormItem";
import React, { useEffect, useState } from "react";

const UsersSelect = (props: any) => {
  const {
    entity,
    setEntity,
    field,
    name,
    label,
    dispatch,
    helpText = "",
    multi = true,
    largeWidth = 12,
    mediumWidth = 12,
    smallWidth = 12,
  } = props;
  const [selectedUsers, setSelectedUsers] = useState([entity[field]]);
  useEffect(() => {
    change();
  }, [selectedUsers]);
  const onChangeUser = (item: any) => {
    change();
  };
  const addUsers = (user: any) => {
    let userIds = [];
    let selected = selectedUsers;
    if (multi) {
      selectedUsers.map((sel) => {
        userIds.push({
          id: sel.id,
          name: sel.name,
        });
      });
    }
    userIds.push({
      id: user.id,
      name: user.name,
    });
    let clone: any = {};
    if (multi) {
      Object.assign(clone, entity);
    }
    clone[field] = userIds;
    setEntity(clone);
  };
  const change = () => {
    let clone: any = {};
    if (multi) {
      Object.assign(clone, entity);
    }
    let userIds: any = [];
    let selected: any = selectedUsers;
    if (!multi && selected.length > 1) {
      selected = [];
      selected[0] = selectedUsers[1];
    }
    selected.map((sel: any) => {
      userIds.push({
        id: sel.id,
        name: sel.name,
      });
    });
    clone[field] = userIds;
    setEntity(clone);
  };

  const onRemoveUser = (index: any) => {
    const newUsers = selectedUsers.slice(0);
    newUsers.splice(index, 1);
    setSelectedUsers(newUsers);
    change();
  };

  const fields = {
    fieldMap: {
      last_name: {
        label: t("last_name"),
        number: "2",
        class: "inb-select-width-1",
        type: "default",
        style: { minWidth: "110px", width: "21%", padding: 0 },
      },
      first_name: {
        label: t("first_name"),
        number: "1",
        class: "inb-select-width-1",
        type: "default",
        style: { minWidth: "110px", width: "21%", padding: 0 },
      },
      customer_nbr: {
        label: t("user_nbr"),
        number: "3",
        class: "inb-select-width-2",
        type: "default",
        style: { minWidth: "100px", width: "19%", padding: 0 },
      },
      email: {
        label: t("e-mail"),
        number: "4",
        class: "inb-select-width-3",
        type: "toShorten",
        style: { minWidth: "200px", width: "35%", padding: 0 },
      },
    },
    fieldNames: ["last_name", "first_name", "customer_nbr", "email"],
  };
  const searchParams = {
    param: "q",
    checkFields: ["name"],
  };
  const showFields = ["last_name", "first_name"];
  const disabled = typeof props.disabled !== "undefined" ? props.disabled : "";
  return (
    <>
      <FormItem
        name={name}
        type="inboomaSelect"
        id={"entity_users_" + (typeof entity.id !== "undefined" ? entity.id : "new")}
        sortBy={"last_name"}
        sortDirection={"asc"}
        advanced={true}
        placeholder={t("select_${a}", { a: t("user") })}
        selectedItems={selectedUsers}
        setSelectedItems={setSelectedUsers}
        onChangeHandler={addUsers}
        dispatch={dispatch}
        showFields={showFields}
        container="user-vcard"
        extraStyle={{ maxWidth: "750px" }}
        multiSelect={multi}
        onReset={onRemoveUser}
        fields={fields}
        searchParams={searchParams}
        model={"user"}
        disabled={disabled}
        label={label}
        helpText={helpText}
        largeWidth={largeWidth}
        mediumWidth={mediumWidth}
        smallWidth={smallWidth}
      />
    </>
  );
};
export default UsersSelect;
